module.exports = __webpack_public_path__ + "media/images/new/see_favorites_in_search@2x-eae240b04d0de5f8d019902bd337d91e.jpg";